import React, { useState } from "react";
import { toast } from "sonner";
import { FlaskConical, Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

const ACTIONS = [
  { key: "renovar", label: "Renovar (cobro aprobado)", help: "Llega el fin del periodo y Stripe cobra. Si había una cancelación programada, el plan termina." },
  { key: "renovar_rechazado", label: "Renovar con cobro rechazado", help: "El cobro falla: el plan queda con pago pendiente." },
  { key: "recuperar", label: "Recuperar cobro pendiente", help: "La persona actualiza su tarjeta y Stripe cobra lo pendiente." },
  { key: "agotar_reintentos", label: "Agotar reintentos", help: "Stripe deja de reintentar y cancela la suscripción." },
];

// Solo con STRIPE_SIMULADO: hace avanzar la suscripción del cliente como lo haría Stripe con el tiempo.
export function StripeSimulator({ userId, onDone }: { userId: string; onDone: () => void }) {
  const [busy, setBusy] = useState("");

  const run = async (action: string) => {
    setBusy(action);
    try {
      const { data } = await api.post(`/admin/users/${userId}/stripe-simulator`, { action });
      toast.success(data.message);
      // Los eventos de Stripe llegan como webhook un instante después.
      setTimeout(onDone, 600);
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(""); }
  };

  return (
    <section className="card-obsidian p-5 border-dashed border-amber-500/50" aria-labelledby="stripe-sim-title" data-testid="stripe-simulator">
      <h3 id="stripe-sim-title" className="text-sm font-semibold text-slate-800 flex items-center gap-2">
        <FlaskConical className="w-4 h-4 text-amber-700" aria-hidden="true" /> Simulador de Stripe
      </h3>
      <p className="text-xs text-slate-600 mt-1">Pagos simulados (sin Stripe real). Cada acción genera los eventos que mandaría Stripe y los procesa el mismo código del webhook.</p>
      <div className="grid sm:grid-cols-2 gap-2 mt-3">
        {ACTIONS.map((a) => (
          <Button key={a.key} variant="outline" onClick={() => run(a.key)} disabled={!!busy} title={a.help} data-testid={`sim-${a.key}`}
            className="h-auto py-2 justify-start text-left whitespace-normal border-slate-200 text-slate-700 rounded-lg">
            {busy === a.key ? <Loader2 className="w-4 h-4 animate-spin" aria-label="Procesando" /> : null}
            <span><span className="block text-sm font-medium">{a.label}</span><span className="block text-xs text-slate-600 font-normal">{a.help}</span></span>
          </Button>
        ))}
      </div>
    </section>
  );
}
